import type { StatsGridComponent } from "../../types";
import { Reveal } from "../../components/motion/Reveal";
import { StatCounter } from "../../components/motion/StatCounter";

/**
 * Statistical KPI grid — dark premium cards: carbon base with a radial green
 * glow in the corner, green ring that brightens on hover, mint eyebrow title,
 * and a white count-up value (StatCounter animates on first view, renders the
 * final string on the server). Cards enter with a stagger.
 */
export function StatsGridRenderer({ component }: { component: StatsGridComponent }) {
  const { items } = component.content;
  return (
    <section>
      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
        {items.map((m, i) => (
          <Reveal key={i} delay={i * 100}>
            <div className="relative h-full overflow-hidden rounded-2xl bg-[var(--color-carbon-2)] text-white ring-1 ring-white/10 transition hover:ring-[#00B862]/50 hover:shadow-[var(--shadow-e2)]">
              {/* Solid green top line — the only green on the card. */}
              <div className="absolute inset-x-0 top-0 h-0.5 bg-[#00B862]" aria-hidden="true" />
              <div className="relative flex h-36 flex-col items-center justify-center p-4 text-center md:h-40">
                <div className="apa-eyebrow apa-eyebrow-light">{m.title}</div>
                <div className="mt-2 text-4xl font-extrabold tracking-tight md:text-5xl" style={{ fontFamily: "var(--font-aleo)" }}>
                  <StatCounter value={String(m.value ?? "")} />
                </div>
                {m.meta ? <div className="mt-1 text-[11px] text-white/55 md:text-xs">{m.meta}</div> : null}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
